import React from 'react';
import { object } from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Card from '../Card/Card';
import TransitFeaturesItem from './TransitFeaturesItem';
import Hint from '../Hint/Hint';
import NewsShowcase from './NewsShowcase';

const propTypes = {
  featuresList: object,
};

const TransitsFeatures = ({
  featuresList,
  transit_comebacker,
  toggleComebacker,
  disabled,
  handleTransitFeatureChange,
  handleNewsShowcaseSettingsChange,
  className,
}) => {
  return featuresList ? (
    <Card.Body
      className={className ? `${className} flow-transit-features` : 'flow-transit-features'}
    >
      <ul className="feature-list">
        <li className="feature-list-item">
          <TransitFeaturesItem
            key={`transit_comebacker`}
            id={`transit_comebacker`}
            name={`transit_comebacker`}
            checked={!!transit_comebacker}
            disabled={disabled}
            value={1}
            onChange={toggleComebacker}
          >
            <FormattedMessage
              id={'flow.features.transits.comebacker.label'}
              defaultMessage={'Enable ComeBacker Script'}
            />
          </TransitFeaturesItem>

          <FormattedMessage
            id={'flow.features.transits.comebacker.title'}
            defaultMessage={'ComeBacker is a tool to increase conversion through exit traffic.'}
          >
            {title => (
              <Hint title={title} id={`transit_comebacker_hint`} placement="right">
                <FormattedHTMLMessage
                  tagName="div"
                  id={'flow.features.transits.comebacker.desc'}
                  defaultMessage={
                    "<p>When you try to close the transit page, the user will see a message about the discount, for which you need to stay on the page. This method allows in most cases to significantly increase the conversion. We recommend that you activate this feature. ComeBacker is currently available on most transit pages. If there is no ComeBacker for the necessary page, write to the support service. </ p> <span class = 'bold'> Warning! </ Span> When activating ComeBacker, we recommend testing the script before sending traffic"
                  }
                />
              </Hint>
            )}
          </FormattedMessage>
        </li>

        <li className="feature-list-item">
          <TransitFeaturesItem
            key={`rt_discount_block`}
            id={`5`}
            name={`5`}
            checked={featuresList['5']}
            disabled={disabled}
            value={1}
            onChange={handleTransitFeatureChange}
          >
            <FormattedMessage
              id={'flow.features.transits.discount_banner.label'}
              defaultMessage={'Banner "How to order at a discount"'}
            />
          </TransitFeaturesItem>

          <Hint id={`transit_rt_discount_block_hint`} placement="right">
            <FormattedHTMLMessage
              tagName="div"
              id={'flow.features.transits.discount_banner.desc'}
              defaultMessage={'Banner "How to order at a discount" at the bottom of the page'}
            />
          </Hint>
        </li>

        <li className="feature-list-item news-showcase">
          <NewsShowcase
            changeFeature={handleTransitFeatureChange}
            featuresList={featuresList}
            disabled={disabled}
            changeShowcaseSettings={handleNewsShowcaseSettingsChange}
          />
        </li>
      </ul>
    </Card.Body>
  ) : null;
};

TransitsFeatures.propTypes = propTypes;

export default TransitsFeatures;
